<template>
  <div>
    <div
      class="flex items-center"
      :style="{ width: !isNaN(width) ? width + 'px' : width }"
    >
      <div
        v-show="editingMode"
        class="ms-input flex items-center w-full"
        :class="{ isValid: errorProvider.isValid, 'input-disabled': disabled }"
      >
        <div
          v-if="icon && !iconAfter"
          :class="['icon-input', 'mi', 'mi-18', 'pointer', icon]"
          @click="$emit('iconClick')"
        />
        <textarea
          :ref="controlRef"
          v-model="internalText"
          :maxlength="maxLength"
          class="ms-input-item"
          :placeholder="placeholder"
          :disabled="disabled"
          :editable="editable"
          :autofocus="autofocus"
          :style="{ height: height + 'px' }"
          :tabindex="tabindex"
          v-on="listeners"
          @keydown.enter.shift.stop
          @keydown.enter.exact="keyEnter"
          @input="onChangeValue"
        />
        <div
          v-if="showSendButton"
          class="send-button"
          @click="onSendClick"
        >
          Gửi
        </div>
        <ms-tooltip
          v-if="errorProvider.isValid"
          class="icon-input-tree-select"
          :show-tooltips="false"
        >
          <template #text>
            {{ errorProvider.message }}
          </template>
          <div>
            <div class="mi mi-20 mi-icon-error mr-2" />
          </div>
        </ms-tooltip>
        <div
          v-if="icon && iconAfter"
          :class="['icon-input', 'mi', 'mi-18', 'pointer', icon]"
          @click="$emit('iconClick')"
        />
      </div>
      <div
        v-if="editable && editingMode"
        class="flex m-l-8"
      >
        <ms-icon
          icon="mi-file-green"
          :tooltip-content="$t('i18nCommon.Save')"
          @click="saveEditMode"
        />
        <ms-icon
          icon="mi-circle-close-red"
          :tooltip-content="$t('i18nCommon.Cancel2')"
          @click="closeEditMode"
        />
      </div>
      <div
        v-show="editable && !editingMode"
        class="flex w-full"
        @dblclick="clickEditBtn"
      >
        <ms-text-border
          class="text-border"
          height="auto"
          style="line-height: 20px"
        >
          <span
            :title="internalText"
            class="internal-text"
          >{{
            getInternalText
          }}</span>
          <template #icon>
            <ms-icon
              v-if="permission"
              icon="mi-pencil"
              :tooltip-content="$t('i18nCommon.Edit')"
              @click="clickEditBtn"
            />
            <ms-icon
              v-if="!permission"
              icon="mi-lock"
            />
          </template>
        </ms-text-border>
      </div>
    </div>
    <p
      v-if="
        !disabled &&
          errorProvider.isValid &&
          ((editable && editingMode) || !editable)
      "
      :class="{ 'text-error': errorProvider.isValid }"
    >
      {{ errorProvider.message }}
    </p>
  </div>
</template>
<script>
import { formatMoney } from "../ms-number/convertCurrency";
import msBaseComponent from "@/components/controls/msbase/msBaseComponent.vue";
import { MsControlRef } from "@/models/enums/MsControlRefConst.js";

export default {
  name: "MsTextarea",
  extends: msBaseComponent,
  props: {
    width: {
      type: [String, Number],
      default: "auto",
    },
    /**
     * V-model bắn ra ngoài binding 2 chiều
     */
    value: {
      type: String,
      default: ''
    },
    /**
     * Hiện thị chũ mờ ở dưới ô input
     * Created by LTDAT(22.06.2020)
     */
    showSendButton: {
      default: false,
      type: Boolean,
    },
    placeholder: {
      default: '',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    //class chứa icon
    icon: {
      default: null,
      type: String,
    },
    height: {
      default: 76,
      type: [String, Number],
    },
    maxLength: {
      default: 255,
      type: [Number, String],
    },
    tabindex: {
      type: [String, Number],
      default: 1,
    },
    iconAfter: {
      type: Boolean,
      default: false,
    },
    editable: {
      type: Boolean,
      default: false,
    },
    permission: {
      type: Boolean,
      default: true,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    // custom validate
    paramValidate:{
      type: Object,
      default: () => {}
    },
    // Kiểu dữ liệu
    dataType: {
      type: String,
      default: "text",
    },
  },
  data() {
    return {
      internalText: this.value,
      focused: false,
      // set chế độ edit = fasle khi editable = true
      editingMode: !this.editable,
      controlRef: MsControlRef.MsTextarea
    };
  },
  computed: {
    listeners() {
      return {
        blur: (e) => {
          this.onBlur(e);
        },
        focus: (e) => {
          this.onFocus(e);
        },
        change: (e) => {
          // this.validate(this.internalText);
          this.$emit("change", this.internalText, e);
        },
        input: (e) => {
          // this.validate(this.internalText);
          this.$emit("changed", this.internalText);
        },
        keydown: (e) => {
          event.stopPropagation();
          this.onKeyDown(e);
        },
        mouseup: (e) => {
          this.onMouseUp(e);
        },
        keyup: (e) => {
          this.onKeyUp(e);
        },
      };
    },
    isEditingMode() {
      return this.$store.getters.getEditingMode;
    },
    // Format khi kiểu dữ liệu là số/tiền tệ
    getInternalText() {
      if (this.internalText) {
        if (
          (this.dataType == "money" || this.dataType == "number") &&
          !this.internalText.startWith("=")
        ) {
          return formatMoney(this.internalText);
        }
        return this.internalText;
      }
      return "";
    },
  },
  watch: {
    internalText: {
      handler(newVal, oldVal) {
        const me = this;
        me.validate(newVal);
        me.$emit("input", newVal);
      },
    },
    value: {
      handler(newVal, oldVal) {
        const me = this;
        me.setValue(newVal);
      },
    },
    /**
     * custom validate
     */
    paramValidate: {
      immediate: true,
      deep: true,
      handler(val) {
        let me = this;
        //Nếu validate đang true và kphai custom thì return
        if (
          me.errorProvider &&
          me.errorProvider["isValid"] &&
          (!val || (val && me.errorProvider["rules"] != val.rules))
        ) {
          return;
        }

        if (val && val.isValid) {
          me.$set(me.errorProvider, "message", val.message);
          me.$set(me.errorProvider, "isValid", true);
          me.errorProvider.rules = val.rules;
          me.errorProvider.element = me.$refs[this.controlRef];
        } else {
          me.errorProvider = {};
        }
      },
    },
    editable: {
      immediate: true,
      handler(val) {
        this.$store.dispatch("setEditingMode", false);
        this.editingMode = !val;
      },
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$nextTick(() => this.$refs[this.controlRef].focus());
    }
  },
  methods: {
    /**
     * @override
     */
    focusError(){
      this.$refs[this.controlRef].focus();
    },
    /**
     * Sự kiện nhấp chuột
     */
    onMouseUp(e) {
      this.$emit("mouseup", e);
    },
    onKeyUp(e) {
      this.$emit("keyup", e);
    },
    /**
     * Sự kiện input thay đổi
     * Created by thduong 19/3/2021
     */
    onChangeValue(e) {
      this.$emit("valueChange", this.$refs[this.controlRef].value, e);
      this.$emit("onChange", this.$refs[this.controlRef].value);
    },
    onSendClick() {
      this.$emit("onSendClick", this.internalText);
    },
    //Sự kiện focus vào ô input
    onFocus(e) {
      const me = this;
      me.focused = true;
      me.$emit("focus", e);
    },
    //Sự kiên blur ra ngoài ô input
    onBlur(e) {
      const me = this;
      me.focused = false;
      me.$emit("blur", e);
    },
    //Sự kiện focus vào ô input
    onKeyDown(e) {
      const me = this;
      me.$emit("keydown", e);
    },
    //Reset lại giá trị về ban đầu
    reset() {
      const me = this;
      me.internalText = null;
    },
    //Set giá trị cho ô input
    setValue(value) {
      const me = this;
      me.internalText = value;
    },
    focusTextArea() {
      this.$nextTick(() => this.$refs[this.controlRef] && this.$refs[this.controlRef].focus());
    },
    /**
     * Hàm xử lý khi click icon edit
     * created by pdthien 21.01.2021
     */
    clickEditBtn() {
      if (!this.isEditingMode) {
        this.oldValue = this.value;
        this.editingMode = !this.editingMode;
        this.$nextTick(() => this.$refs[this.controlRef] && this.$refs[this.controlRef].focus());
        this.$emit("clickEditBtn");
        this.$store.dispatch("setEditingMode", true);
      }
    },
    /**
     * Hàm xử lý khi đóng chế độ edit
     * created by pdthien 21.01.2021
     */
    closeEditMode() {
      this.editingMode = false;
      this.value = this.oldValue;
      this.$emit("closeEditMode");
      this.$store.dispatch("setEditingMode", false);
    },
    /**
     * Hàm xử lý khi đóng chế độ edit không emit (dùng cho MsFormula)
     * created by pdthien 21.01.2021
     */
    closeEditModeWithoutEmit() {
      if (!this.errorProvider.isValid) {
        this.editingMode = false;
        this.value = this.oldValue;
        this.$store.dispatch("setEditingMode", false);
      }
    },
    /**
     * Hàm xử lý khi lưu edit
     * created by pdthien 21.01.2021
     */
    saveEditMode() {
      this.$emit("onSaveData");
    },
    /**
     * Hàm set editingMode = false
     */
    closeEditingMode() {
      this.editingMode = false;
      this.$store.dispatch("setEditingMode", false);
    },
    keyEnter(e) {
      e.stopPropagation();
      e.preventDefault();
      this.$emit("keyEnter");
      this.$emit("onSendClick", this.internalText);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/controls/msTextarea.scss";
.ms-input-item {
  padding: 6px 0;
}
.ms-input {
  position: relative !important;
  // min-height: 76px !important;
}
.icon-input-tree-select {
  position: absolute !important;
  right: 6px !important;
}
.pointer {
  cursor: pointer;
}
.send-button {
  color: var(--primary);
  padding: 0 4px;
  cursor: pointer;
}
.internal-text {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>

